var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.formattedStart)+" - "+_vm._s(_vm.formattedEnd)+" ")]},null,{start: _vm.formattedStart, end: _vm.formattedEnd, duration: _vm.formattedDuration})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }